import React from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { useCardTransition } from '..'
import Text from '../../../../components/atoms/text/Text'
import IconClose from '../../../../components/icons/IconClose'
import styles from './CardTransition.module.css'
import { VARIANTS } from '../../../../types/Components.types'

interface IProps {
  shown: boolean
  children: React.ReactNode
  title?: string
}

const CardTransition = ({ shown, children, title }: IProps) => {
  const { closeCard } = useCardTransition()

  return (
    <AnimatePresence>
      {shown && (
        <motion.div
          className={styles.container}
          initial={{ opacity: 0, y: '50%', x: '-50%' }}
          animate={{ opacity: 1, y: '-50%', x: '-50%' }}
          exit={{ opacity: 0, y: '50%', x: '-50%' }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <div className={styles.wrapper}>
            <div className={styles.header}>
              {title ? (
                <Text element="h2" variant={VARIANTS.primary} weight={600} size="l">
                  {title}
                </Text>
              ) : (
                <div />
              )}
              <button className={styles.closeIcon} onClick={closeCard}>
                <IconClose className={styles.icon} variant="max" size="xs" />
              </button>
            </div>
            <div className={styles.content}>{children}</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default React.memo(CardTransition)
